import { GetReservationDetailsRequest } from '@appTypes/api.types';
import { CalcCheckoutPayload } from '../checkout.types';

export class calcCheckout {
  static readonly type = '[Checkout] GetCheckoutFormData';
  constructor(public payload?: CalcCheckoutPayload) {}
}

export class confirmCheckoutFormData {
  static readonly type = '[Checkout] ConfirmCheckout';
  constructor(public payload?: CalcCheckoutPayload) {}
}

export class checkOutClearFormData {
  static readonly type = '[Checkout] ClearFormData';
}

export class checkoutVerifyCalculatedPrices {
  static readonly type = '[Checkout] CheckoutVerifyCalculatedPrices';
  constructor(public payload?: CalcCheckoutPayload) {}
}

export class checkOutGetReservationDetailsData {
  static readonly type = '[Checkout] GetReservationDetailsData';
  constructor(public payload: GetReservationDetailsRequest) {}
}
